import { memo } from "react";

import { OpenShiftCreated } from "~/api/eventLog/events";

import { EventLog } from "@/api";
import { ShiftV2 } from "@/common/components/Shift/ShiftV2";
import { Author } from "@/common/components/StaffShiftHistoryModal/helpers/Author";

import { IEventLogComponent } from "../";

import { OpenShiftDetails } from "./helpers";

export const OpenShiftDeletedV1 = memo(
  ({
    event,
    indexedShiftTypes,
    usersById,
  }: IEventLogComponent<
    EventLog.DTO<OpenShiftCreated.PayloadByVersion[OpenShiftCreated.EVersions.v1]>
  >) => {
    const openShift = event.eventPayload.openShift;
    const shiftType = indexedShiftTypes?.[openShift.scheduleId]?.[openShift.shiftType];

    return (
      <>
        <Author authorId={event.authorId} usersById={usersById} />{" "}
        <span data-testid="description">
          deleted the {shiftType ? <ShiftV2 variant="small" shiftType={shiftType} /> : ""} open
          shift.
        </span>
        <OpenShiftDetails origin={event.eventPayload.origin} />{" "}
      </>
    );
  },
);
